//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapActions, mapGetters} from 'vuex';

export default {
  async created() {
    await Promise.all([
      await this.setProducts(),
      await this.setPartner()
    ]);
  },
  computed: {
    ...mapGetters(['getPartner'])
  },
  methods: {
    ...mapActions(['setProducts', 'setPartner']),
  }
}
